<template>
    <commonbody>
        <div class="row mx-0" slot="swiper">
            <div class="home-swiper-box" v-if="imgData.length">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(item, key) in imgData" :key="key">
                        <img :src="'/express_api' + getCarouselImgUrl(item)" :alt="item.title" />
                        <div class="home-swiper-text">
                            <h5 class="home-swiper-text-title">葡旅葡萄酒</h5>
                            <h6><img src="../../public/images/banner_icon.png"></h6>
                            <p class="home-swiper-text-text">{{ item.title }}</p>
                            <div class="home-swiper-text-btn" v-if="item.linkUrl" @click="openLink(item.linkUrl)">
                                立即选购
                            </div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div> -->
                </swiper>
            </div>
        </div>
        <div :class="['clearfix', getCommonStyle.class]" id="home-box" :style="getCommonStyle.style">
            <div class="home-content-box">
                <div class="home-separation-box">
                    <img src="../../public/images/1.png" />
                </div>
                <div class="home-corp-box">
                    <div class="row corp-main-box common-width-box">
                        <div class="col-6 col-md-12 col-lg-6 card border-0 px-0 py-0 home-corp-content-left">
                            <img src="../../public/images/left_logo.png" />
                        </div>
                        <div class="col-6 col-md-12 col-lg-6 card border-0 px-0 py-0">
                            <div class="home-corp-content-box">
                                <div class="common-subtitle-box" style="text-align: left;">葡旅葡萄酒</div>
                                <div class="home-corp-content-text">
                                    <p><i>苏州葡旅</i>葡萄酒进出口贸易有限公司成立于<i>2014</i>年<i>1</i>月，由几位资深葡萄酒爱好者自发组织成立。我们致力于为葡萄酒爱好者提供专业的甄选、采购和运输服务，其创始本意是为葡萄酒爱好者提供全方位的服务。</p>
                                    <p>葡旅专注于甄选纯净可口、美味天然的有机、生物动力和自然酿法葡萄酒。其创始团队连续多年深入欧洲各大葡萄酒产区酒庄实地考察，品鉴。
                                        目前，旗下共独家代理来自法国，意大利，西班牙，葡萄牙，德国，奥地利等国家的<i>38</i>个精品自然酒庄共<i>300</i>余款葡萄酒。 此外，公司还投资设立了苏州葡旅文化传播有限公司，致力于葡萄酒文化的传播、葡萄酒专业认证培训、葡萄酒相关赛事以及各类沙龙、论坛活动。</p>
                                    我们希望通过不断地探索那些隐匿在大自然里的美酒，将风土人情带入爱好者的餐桌。让葡萄酒文化不再高高在上，自然而然成为丰富你我生活的一部分。
                                </div>
                                <div class="common-btn" @click="readClick('/zoom')">MORE</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="home-corp-box home-team-box" style="display: none;">
                    <div class="common-subtitle-box">
                        我们的团队<i>Our team</i>
                    </div>
                    <div class="row corp-main-box common-width-box">
                        <div class="col-6 col-md-12 col-lg-6 card border-0 px-0 py-0">
                            <div class="home-corp-content-box">
                                <div class="common-subtitle-box" style="text-align: left;">葡旅葡萄酒图团队</div>
                                <div class="home-corp-content-text">
                                    <p><i>苏州葡旅</i>葡萄酒进出口贸易有限公司成立于<i>2014</i>年<i>1</i>月，由几位资深葡萄酒爱好者自发组织成立。我们致力于为葡萄酒爱好者提供专业的甄选、采购和运输服务，其创始本意是为葡萄酒爱好者提供全方位的服务。</p>
                                    <p>葡旅专注于甄选纯净可口、美味天然的有机、生物动力和自然酿法葡萄酒。其创始团队连续多年深入欧洲各大葡萄酒产区酒庄实地考察，品鉴。
                                        目前，旗下共独家代理来自法国，意大利，西班牙，葡萄牙，德国，奥地利等国家的<i>38</i>个精品自然酒庄共<i>300</i>余款葡萄酒。 此外，公司还投资设立了苏州葡旅文化传播有限公司，致力于葡萄酒文化的传播、葡萄酒专业认证培训、葡萄酒相关赛事以及各类沙龙、论坛活动。</p>
                                    我们希望通过不断地探索那些隐匿在大自然里的美酒，将风土人情带入爱好者的餐桌。让葡萄酒文化不再高高在上，自然而然成为丰富你我生活的一部分。
                                </div>
                            </div>
                        </div>

                        <div class="col-6 col-md-12 col-lg-6 card border-0 py-0 home-corp-content-left">
                            <img src="../../public/images/team.png" />
                        </div>
                    </div>
                </div>


                <div class="row mx-0 home-space-box common-margin">
                    <div class="common-subtitle-box">葡旅酒空间<i>Vinetrails'  Wine Salon</i></div>
                    <!-- <div class="pub-lang">有机种植，自然酿造！我们只选者那些真正能反应风土的特色美酒。</div> -->
                    <div class="home-swiper-box common-width-box">
                        <swiper ref="mySwiper2" :options="swiperOptions2">
                            <swiper-slide v-for="(item, key) in spaceData" :key="key">
                                <div class="home-space-swiper-box">
                                    <img :src="item.cover_url" :alt="item.title" />
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                        <div class="home-space-address-box">
                            地址:苏州园区通园路80号，56文创园D栋，葡旅葡萄酒空间。空间预约电话:0512-67583697
                        </div>
                    </div>
                </div>

                <div class="row mx-0 home-chateau-box common-margin" v-if="caseData.length">
                    <div class="common-subtitle-box">代理酒庄<i>Wine Makers</i></div>
                    <div class="pub-lang common-width-box">有机种植，自然酿造！我们只选择那些真正能反应风土的特色美酒。</div>
                    <div class="home-swiper-box common-width-box">
                        <swiper ref="mySwiper1" :options="swiperOptions1">
                            <swiper-slide v-for="(item, key) in caseData" :key="key">
                                <div class="home-chateau-swiper-box" @click="skipHateauDetails(item.id)">
                                    <img :src="'/express_api' + item.cover_url" :alt="item.title" />
                                    <div class="home-chateau-text">
                                        {{ item.title }}
                                        {{ item.english_title }}
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                    </div>
                </div>

                <div class="home-wine-box common-margin">
                    <div class="common-subtitle-box">新到酒款<i>New Arrivals</i></div>
                    <div class="pub-lang common-width-box">有机种植，自然酿造！我们只选择那些真正能反应风土的特色美酒。</div>
                    <div class="row wine-main-box common-width-box" v-if="caseDetailsData.length">
                        <div class="col-3 col-md-6 col-lg-3 border-0 px-0 py-0 my-3" v-for="(item, key) in caseDetailsData"
                            :key="key">
                            <Card :cardData="item" :isInfo="false" />
                        </div>
                    </div>
                    <p v-else>
                        暂无数据
                    </p>
                    <!-- <div class="common-btn" @click="clickEvent()">
                    查看更多
                </div> -->
                </div>

                <div class="home-case-box common-margin">
                    <div class="common-subtitle-box">最新媒体动态<i>Latest media updates</i></div>
                    <div class="pub-lang common-width-box">关注我们的社交媒体，获取最新的葡萄酒动态吧。</div>
                    <div class="row case-main-box common-width-box">
                        <div class="col-3 col-md-6 col-lg-3 card border-0 px-3 my-3" v-for="(item, key) in productData"
                            :key="key" @click="openLink(item.external_link)">
                            <img class="img-thumbnail" :src="'/express_api' + item.cover" />
                            <div class="card-body pb-0">
                                <h4 class="mb-0">{{ item.title }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </commonbody>
</template>

<script>
// @ is an alias to /src
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import commonbody from '@/components/commonbody.vue';
import "swiper/css/swiper.min.css";
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";
import { selectNews } from '@/api/news';
import * as carouselApi from '@/api/carousel';
import * as corporationApi from '@/api/corporation';
import * as casesApi from '@/api/cases';
import Card from "@/components/card.vue";
import { mapState, mapGetters } from 'vuex';
import { EquipmentType } from '@/constants';

export default {
    name: "Home",
    components: {
        NavHeader,
        Swiper,
        SwiperSlide,
        Footer,
        Card,
        commonbody,
    },
    data() {
        return {
            serveIndex: 0,
            //轮播图
            imgData: [],
            //公司详细数据
            corporationDetails: {},
            //酒庄数据
            caseData: [],
            caseDetailsData: [],
            //
            productData: [
            ],
            //葡旅空间数据
            spaceData: [
                {
                    cover_url: require("../../public/images/home/space/space1.png"),
                },
                {
                    cover_url: require("../../public/images/home/space/space2.png"),
                },
                {
                    cover_url: require("../../public/images/home/space/space3.png"),
                },
            ],
        };
    },
    computed: {
        ...mapState(['currentEquipment']),
        ...mapGetters(['getCommonStyle']),
        swiper() {
            return this.$refs?.mySwiper?.$swiper;
        },
        swiper1() {
            return this.$refs?.mySwiper1?.$swiper;
        },
        swiper2() {
            return this.$refs?.mySwiper2?.$swiper;
        },
        //轮播配置项
        swiperOptions() {
            return {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false // 手动切换之后继续自动轮播
                },
                loop: this.imgData.length != 1,
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // }
            }
        },

        swiperOptions1() {
            let temp = {
                speed: 700,
                allowTouchMove: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3,
                },
                centeredSlides: true,
                spaceBetween: 20,
                slidesOffsetBefore: 0,
                slidesPerView: 4,
            }

            if (this.currentEquipment != EquipmentType.PC) {
                temp = {};
            }
            return {
                ...temp,
                loop: this.caseData.length != 1,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<div class="' + className + '"><span></span><i></i></div>';
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
        },

        //轮播配置项
        swiperOptions2() {
            return {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false // 手动切换之后继续自动轮播
                },
                loop: this.spaceData.length != 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }
        },
    },
    created() {
        this.initPage();
    },
    methods: {
        getCarouselImgUrl(item) {
            return this.currentEquipment != EquipmentType.PC ? item.mpicture_url : item.picture_url;
        },
        initPage() {
            this.selectCarousel();
            this.getCorporationData();
            this.getCaseData();
            this.getCaseDetailsData();
            this.selectNews();
        },
        openLink(linkUrl) {
            if (linkUrl) {
                window.open(linkUrl);
            }
        },
        clickEvent() {
            this.$router.push({
                path: '/wine',
            })
        },
        /**
         * @desc 获取轮播图数据
         */
        selectCarousel() {
            let params = {
                type: 1,
            }
            carouselApi.selectCarousel(params).then(res => {
                this.imgData = res.data || [];
            })
        },
        /**
         * @desc 获取公司数据
         */
        getCorporationData() {
            let params = {
            }
            corporationApi.selectData(params).then(res => {
                this.corporationDetails = (res?.data && res?.data[0]) || {};
            })
        },
        /**
         * @desc 获取酒庄数据
         */
        getCaseData() {
            let params = {
            }
            casesApi.selectCases(params).then(res => {
                this.caseData = res.data || [];
            })
        },
        /**
         * @desc 获取酒数据
         */
        getCaseDetailsData() {
            let params = {
                isHot: 1,
                page: 1,
                size: 8,
            }
            casesApi.selectCaseDetailsAll(params).then(res => {
                this.caseDetailsData = res.data || [];
            })
        },
        /**
         * @desc 跳转动态详情
         */
        skipHateauDetails(id) {
            console.log(id)
            this.$router.push({
                path: '/wineryDetails',
                query: {
                    id
                }
            })
        },
        /**
         * @desc 查看更多点击
         */
        readClick(url) {
            this.$router.push({
                path: url
            })
        },
        /**
         * @desc 获取媒体数据
         */
        selectNews() {
            let params = {
                page: 1,
                size: 8,
            }
            selectNews(params).then(res => {
                this.productData = res.data || [];
            })
        },
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
//轮播样式
.home-swiper-box {
    width: 100%;
    overflow: hidden;
    position: relative;

    .swiper-button-next,
    .swiper-button-prev {
        // border: 1px solid #cccccc;
        padding: 10px;
        color: #EDF0FB;
        width: 100px;
        height: 100px;
        // top: calc(50% - 50px);

        &:hover {
            color: #DA4747;
        }
    }

    img {
        width: 100%;
        // max-height: 750px;
        max-height: 100vh;
    }

    .home-swiper-text {
        width: 100%;
        position: absolute;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        height: 100vh;
        top: 0;
        left: 0;
        align-content: center;
        color: #fff;
        opacity: 0;
        animation: fadeInUp 1s ease forwards;


        .home-swiper-text-title {
            font-size: 68px;
            width: 100%;
            margin-bottom: 10px;
            padding-bottom: 10px;
            font-family: serif;
        }

        .home-swiper-text-text {
            font-size: 18px;
            width: 30%;
            margin-bottom: 10px;
        }

        .home-swiper-text-btn {
            width: 100%;
            font-size: 18px;
            color: #fff;
            margin-right: 10px;
            display: inline-block;
            cursor: pointer;
            height: 30px;

            &:hover {
                // font-size: 20px;
                color: #470125;
                transition: all 0.5s;
            }
        }

        h6 {
            width: 100%;
            margin-bottom: 15px;
        }

        img {
            max-width: 100%;
            width: auto;
            height: auto;
            display: inline-block;
        }
    }
}

#home-box {
    width: 100%;
    overflow: hidden;

    .home-content-box {

        .home-separation-box {
            img {
                max-height: 60px;
            }
        }

        .home-corp-box {
            // height: 600px;
            width: 100%;
            overflow: hidden;
            text-align: left;
            padding: 60px 0;

            .corp-main-box {
                // width: 80%;
                max-width: 1536px;
                margin: 0 auto;
            }

            .row {
                height: 100%;
                padding-bottom: 40px;
            }

            .home-corp-content-left {
                position: relative;
                text-align: right;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: 100%;
                }

            }

            .home-corp-content-box {
                // margin-left: 60px;

                .home-corp-content-text {
                    text-indent: 2em;
                    margin: 0px auto 20px;
                    // max-height: 56%;
                    overflow: hidden;
                    color: #000;
                    text-align: justify;

                    p {
                        margin-bottom: 20px;

                        i {
                            font-size: 1.2em;
                            font-weight: bold;
                        }
                    }
                }

                .common-btn {
                    float: right;
                    background: #470125;
                    border-color: #470125;
                    color: #fff;

                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }

        .home-team-box {
            background: #f9f7f4;

            .card {
                background: transparent;
            }

            .home-corp-content-box {
                margin-right: 60px;
            }

            .home-corp-content-left {
                padding-left: 60px;
            }
        }

        .home-space-box {
            width: 100%;
            margin: 0 auto;
            background: #f9f7f4;
            padding: 100px 0;

            .home-swiper-box {
                // width: 80%;
                max-width: 1536px;
                margin: 0 auto;

                .home-space-address-box {
                    text-align: left;
                    margin-top: 10px;
                }
            }

            .home-space-swiper-box {
                img {
                    height: auto;
                }
            }
        }

        .home-chateau-box {
            width: 100%;
            margin: 0 auto;
            background: #fff;
            padding: 100px 0;

            .home-swiper-box {
                // width: 80%;
                max-width: 1536px;
                margin: 0 auto;

                .home-chateau-swiper-box {
                    position: relative;

                    img {
                        height: auto;
                        cursor: pointer;
                        // height: 700px;
                    }

                    .home-chateau-text {
                        left: 0px;
                        bottom: 0px;
                        background: rgba(0, 0, 0, 0.7);
                        width: 100%;
                        color: #fff;
                        line-height: 30px;
                        box-sizing: border-box;
                        text-align: left;
                        transition: all 0.2s linear;
                        height: 0px;
                        box-sizing: border-box;
                        padding: 0;
                        border: 0;
                        overflow: hidden;
                        height: 30px;
                        padding: 0 20px;
                        position: absolute;
                        cursor: pointer;
                        border-radius: 4px;
                    }
                }

                .swiper-pagination {
                    bottom: -3px;
                }
            }
        }

        .home-wine-box {
            width: 100%;
            margin: 0 auto;
            padding: 100px 0;
            background: #f9f7f4;

            .wine-main-box {
                // width: 80%;
                max-width: 1536px;
                margin: 0 auto;
            }

            .common-btn {
                margin: 50px auto 0;
            }
        }

        .home-case-box {
            width: 100%;
            margin: 0 auto;
            background: #fff;
            padding: 100px 0;

            .case-main-box {
                // width: 80%;
                max-width: 1536px;
                margin: 0 auto;
            }

            .card {
                position: relative;
                overflow: hidden;
                cursor: pointer;
                border-radius: 0;
                box-sizing: border-box;
                background: transparent;

                .card-body {
                    // display: none;
                    position: absolute;
                    left: 21px;
                    bottom: 4px;
                    background: rgba(0, 0, 0, .7);
                    width: calc(100% - 42px);
                    color: #fff;
                    line-height: 24px;
                    box-sizing: border-box;
                    text-align: left;
                    transition: all 0.2s linear;
                    height: 0px;
                    box-sizing: border-box;
                    padding: 0;
                    border: 0;
                    overflow: hidden;
                    height: 40px;
                    padding: 0 20px;

                    h4 {
                        font-size: 1em;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: 40px;
                    }

                    p {
                        font-size: 1em;
                        line-height: 40px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                img {
                    // height: 300px;
                    max-width: 100%;
                    transition: all 0.2s linear;
                }

                &:hover {
                    img {
                        // transform: scale(1.2);
                    }

                    .card-body {
                        // height: 80px;
                        // padding: 20px;
                    }
                }
            }
        }
    }
}

// @media screen and (min-width: 1360px) and (max-width: 1910px) {
//     #home-box {
//         .home-case-box {
//             width: 1200px;
//         }
//     }
// }</style>
<style lang="scss">
.home-chateau-box {
    .swiper-container {
        padding-bottom: 40px;
    }

    .swiper-wrapper {}

    .swiper-slide {
        width: 770px;
        transition-timing-function: linear;
    }

    @media only screen and (max-width:1200px) {
        .swiper-slide {
            width: 770px;
        }
    }

    @media only screen and (max-width:980px) {
        .swiper-slide {
            width: 471px;
        }
    }

    @media only screen and (max-height:480px) {
        .swiper-slide {
            width: 471px;
        }
    }

    .swiper-slide img {
        width: 100%;
        border-radius: 4px;
    }

    .swiper-slide .title {
        position: absolute;
        transform: rotate(90deg);
        transform-origin: left top;
        left: -3px;
        font-size: 11px;
        color: rgb(102, 102, 102);
    }

    .swiper-button-next,
    .swiper-button-prev {
        width: 86px;
        height: 112px;
        background-size: 86px 112px;
        margin-top: -56px;
        outline: none;
    }

    .swiper-pagination-bullet {
        background: none;
        opacity: 1;
        margin: 0 6px !important;
        width: 9px;
        height: 9px;
        position: relative;
        outline: none;
        vertical-align: middle;
    }

    .swiper-pagination-bullet span {
        width: 3px;
        height: 3px;
        background: #CCC;
        display: block;
        border-radius: 50%;
        margin-top: 3px;
        margin-left: 3px;
    }

    .swiper-pagination-bullet i {
        background: #000;
        height: 1px;
        width: 20px;
        position: absolute;
        top: 4px;
        transform: scaleX(0);
        transform-origin: left;
        z-index: 3;
        transition-timing-function: linear;
    }

    .swiper-pagination-bullet-active span,
    .swiper-pagination-bullet:hover span {
        width: 9px;
        height: 9px;
        margin-top: 0;
        margin-left: 0;
        background: #000;
        position: relative;
        z-index: 1;
    }

    .swiper-pagination-bullet-active i {
        animation: middle 6s;
    }

    .swiper-pagination-bullet:first-child.swiper-pagination-bullet-active i {
        animation: first 6s;
    }

    .swiper-pagination-bullet:last-child.swiper-pagination-bullet-active i {
        animation: last 6s;
    }

    @keyframes first {
        0% {
            transform: scaleX(0.5);
            left: 0px;
        }

        /*091*/
        100% {
            transform: scaleX(1);
            left: 2px;
        }

        /*0915*/
    }

    @keyframes last {
        0% {
            transform: scaleX(0.7);
            left: -10px;
        }

        /*1090*/
        20% {
            transform: scaleX(0.3);
            left: 2px;
        }

        /*090*/
        100% {
            transform: scaleX(0.3);
            left: 0px;
        }

        /*090*/
    }

    @keyframes middle {
        0% {
            transform: scaleX(0.7);
            left: -10px;
        }

        /*1091*/
        20% {
            transform: scaleX(0.45);
            left: 2px;
        }

        /*092*/
        100% {
            transform: scaleX(1);
            left: 2px;
        }

        /*0913*/
    }

}

@-webkit-keyframes fadeInUp {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, 10%, 0);
        transform: translate3d(0, 10%, 0);
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, 10%, 0);
        transform: translate3d(0, 10%, 0);
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}
</style>
